import type { IconName } from "@blueprintjs/icons";

export function buildAdminNavItems(
  organizationId: number,
  isFybrAdmin: boolean
): Array<{ path: string; icon: IconName; label: string }> {
  const items: Array<{ path: string; icon: IconName; label: string }> = [
    {
      path: `/admin/organizations/${organizationId}/settings`,
      icon: "cog",
      label: "Settings",
    },
    {
      path: `/admin/organizations/${organizationId}/users`,
      icon: "user",
      label: "Users",
    },
    {
      path: `/admin/organizations/${organizationId}/folders`,
      icon: "folder-close",
      label: "Folders",
    },
  ];

  if (isFybrAdmin) {
    items.splice(2, 0, {
      path: `/admin/organizations/${organizationId}/groups`,
      icon: "people",
      label: "Groups",
    });
  }

  return items;
}
